module.exports = __webpack_public_path__ + "static/media/spa.5804807c.jpg";